<template>
	<div class="az_r_menu profile-drawer" data-custom-switch-body :id="id" :class="{'active': active}">
		<div class="az_r_menu_ttl">
<!--			<button type="button" class="az_r_menu_ttl_btn back" :data-custom-switch-btn="'#' + buttonBack" v-if="buttonBack.trim()">-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">-->
<!--          <path d="M12.5277 7.33343L5.081 7.33343L8.33434 4.0801C8.59434 3.8201 8.59434 3.39344 8.33434 3.13343C8.07434 2.87344 7.65434 2.87344 7.39434 3.13343L3.001 7.52677C2.741 7.78677 2.741 8.20677 3.001 8.46677L7.38767 12.8668C7.64767 13.1268 8.06767 13.1268 8.32767 12.8668C8.58767 12.6068 8.58767 12.1868 8.32767 11.9268L5.081 8.66677L12.5277 8.66677C12.8943 8.66677 13.1943 8.36677 13.1943 8.0001C13.1943 7.63343 12.8943 7.33343 12.5277 7.33343Z" fill="#7A889B"/>-->
<!--        </svg>-->
<!--			</button>-->

			<div class="az_r_menu_ttl_txt">
				<slot name="title"></slot>
			</div>

			<button @click="closeModal" type="button" class="az_r_menu_ttl_btn cls" :data-custom-switch-btn="'#' + id" v-if="buttonClose">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M12.2005 3.80665C11.9405 3.54665 11.5205 3.54665 11.2605 3.80665L8.00047 7.05998L4.74047 3.79998C4.48047 3.53998 4.06047 3.53998 3.80047 3.79998C3.54047 4.05998 3.54047 4.47998 3.80047 4.73998L7.06047 7.99998L3.80047 11.26C3.54047 11.52 3.54047 11.94 3.80047 12.2C4.06047 12.46 4.48047 12.46 4.74047 12.2L8.00047 8.93998L11.2605 12.2C11.5205 12.46 11.9405 12.46 12.2005 12.2C12.4605 11.94 12.4605 11.52 12.2005 11.26L8.94047 7.99998L12.2005 4.73998C12.4538 4.48665 12.4538 4.05998 12.2005 3.80665Z" fill="#7A889B"/>
        </svg>
			</button>
		</div>


		<div class="az_r_menu_cnt">
			<slot name="content">
				Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad assumenda aut deleniti dicta fugiat incidunt ipsam ipsum magni maiores nam nesciunt odio optio quam quod repudiandae rerum sit unde, veritatis.
			</slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: "BaseRightMenu",
		props: {
			id: {
				type: String,
				required: true,
				default: '',
			},
			buttonClose: {
				type: Boolean,
				default: true,
			},
			buttonBack: {
				type: String,
				default: '',
			},
			active: {
				type: Boolean,
				default: false,
			},
		},
    methods: {
      closeModal(){
        // this.$store.state.profile = ''
      }
    }
	}
</script>
